import { render, staticRenderFns } from "./teamDetail1.vue?vue&type=template&id=c0f7c9e4&scoped=true&"
import script from "./teamDetail1.vue?vue&type=script&lang=js&"
export * from "./teamDetail1.vue?vue&type=script&lang=js&"
import style0 from "./teamDetail1.vue?vue&type=style&index=0&id=c0f7c9e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f7c9e4",
  null
  
)

export default component.exports